export const idID: { [k: string]: string } = {
  // DO NOT REMOVE THIS COMMENT
  
}

export const idID_nonRedundent: { [k: string]: string } = {
  
}
